import requests from '../../dashboard/Locality/Service/httpService';

const ContactService = {
  submitContact(body) {
    return requests.post('/contact', body);
  },
};

export default ContactService;

